import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';

var InternalIcon = function InternalIcon(props, ref) {
  var _context, _classNames;

  var _useContext = useContext(ConfigContext),
      userDefaultProps = _useContext.compDefaultProps;

  var iconProps = getCompProps('Icon', userDefaultProps, props);
  var type = iconProps.type,
      spin = iconProps.spin,
      style = iconProps.style,
      prefix = iconProps.prefix,
      className = iconProps.className,
      rotate = iconProps.rotate,
      onClick = iconProps.onClick,
      onMouseEnter = iconProps.onMouseEnter,
      onMouseLeave = iconProps.onMouseLeave;
  var innerRef = React.useRef();
  var iconRef = ref || innerRef;
  var iconPrefix = prefix || iconProps.iconPrefix;
  var iconClass = classNames(iconPrefix, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(iconPrefix, "-")).call(_context, type), type), _defineProperty(_classNames, "icon-spin", spin), _classNames));

  var handleClick = function handleClick(e) {
    onClick && onClick(e);
  };

  var handleMouseEnter = function handleMouseEnter(e) {
    onMouseEnter && onMouseEnter(e);
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    onMouseLeave && onMouseLeave(e);
  };

  var iconStyle = _extends({}, style);

  if (rotate !== undefined) {
    iconStyle.transform = "rotate(".concat(rotate, "deg)");
  }

  return /*#__PURE__*/React.createElement("i", {
    className: iconClass,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    style: iconStyle,
    ref: iconRef
  });
};

var Icon = /*#__PURE__*/React.forwardRef(InternalIcon);
Icon.displayName = 'Icon';
export default Icon;